import React, { useRef } from "react";
//styles
import classes from "./LandingMobile.module.css"
import LandingContainerMobile from "./LandingContainerMobile/LandingContainerMobile";



//this component renders the Landing Section
const LandingMobile = () =>{
  const container = useRef(null)
  //creates a parallax effect 


    return <div className={classes.container} ref={container}>
      <LandingContainerMobile/>
    </div>
}

export default LandingMobile